/* eslint-disable quote-props */
import {
	EuiListGroup,
	EuiListGroupItem,
	EuiProgress,
} from '@equipmentshare/ds2'

import ComboBox from 'components/ComboBox/comboBox'
import { DeleteBin7LineIcon } from '@equipmentshare/ds2-icons'

import styles from './addList.module.css'

export type AddListProps<T> = {
	isLoading?: boolean,
	id?: string,
	getName: ( item: T ) => string,
	noResultsText?: string,
	noSuggestions?: boolean,
	searchPlaceholder?: string,
	valueKey: keyof T,
	filterList?: ( items: T[], selectedItems: T[] ) => T[],
	itemList: T[],
	selectedItems: T[],
	setSelectedItems: ( items: T[] ) => void,
	itemRender: ( item: T ) => JSX.Element,
	onSearchChange?: ( searchText: string ) => void,
}

export default function AddList<T>( {
	itemList,
	selectedItems,
	filterList,
	setSelectedItems,
	itemRender,
	isLoading,
	getName,
	searchPlaceholder = 'Search...',
	valueKey,
	...props
}: AddListProps<T> ) {
	const availableItems = filterList ? filterList( itemList, selectedItems ) : itemList

	const handleAddItem = ( item?: T ) => {
		if ( item ) {
			setSelectedItems( [
				...selectedItems,
				item,
			] )
		}
	}

	const handleRemoveItem = ( item: T ) => {
		setSelectedItems( selectedItems.filter( ( filterItem ) => filterItem[ valueKey ] !== item[ valueKey ] ) )
	}

	const handleSearchChange = ( searchText: string ) => {
		if ( props.onSearchChange ) {
			props.onSearchChange( searchText )
		}
	}

	return (
		<div>
			<ComboBox
				aria-label="Search"
				placeholder={searchPlaceholder}
				setSelectedOption={handleAddItem}
				data={availableItems}
				getName={getName}
				isLoading={isLoading}
				async={false}
				onSearchChange={handleSearchChange}
				{...props}
			/>
			<EuiListGroup
				bordered
				className={styles.list}
			>
				{ isLoading && <EuiProgress size="xs" />}
				{ selectedItems.map( ( item ) => (
					<EuiListGroupItem
						key={`listItem${item[ valueKey ]}`}
						label={itemRender( item )}
						extraAction={{
							type: 'button',
							iconType: DeleteBin7LineIcon,
							color: 'danger',
							onClick: () => handleRemoveItem( item ),
							'aria-label': 'Remove user'
						}}
					/>
				) ) }
			</EuiListGroup>
		</div>
	)
}
